import { useState } from "react";
import Card from "@/components/base/Card";
import Button from "@/components/base/Button";
import Input from "@/components/base/Input";
import Badge from "@/components/base/Badge";

export default function AdminConfiguracionPage() {
  const [activeTab, setActiveTab] = useState("general");
  const [saved, setSaved] = useState(false);
  const [form, setForm] = useState({
    nombreCol: "Colegio Ezer Antigravity",
    rut: "72.441.500-k",
    director: "Roberto Fuentes",
    iaNivel: "medio",
    notifCasos: true,
    notifPlazos: true,
    auditoriasLogs: true,
  });

  const handleSave = () => {
    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  };

  return (
    <div className="p-4 md:p-6 space-y-5 animate-fade-in-up">
      <div className="flex flex-col sm:flex-row gap-3 items-start sm:items-center justify-between">
        <div>
          <h1 className="text-xl md:text-2xl font-bold text-foreground-950">Configuración del Sistema</h1>
          <p className="text-sm text-foreground-500 mt-0.5">Administra las preferencias generales del colegio, parámetros de la IA y notificaciones activas.</p>
        </div>
        {saved && (
          <Badge variant="primary" className="py-1 px-3 text-xs animate-bounce bg-emerald-100 text-emerald-800 border-emerald-200">
            ✓ Cambios guardados con éxito
          </Badge>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {/* Navigation Tabs */}
        <Card className="p-2 md:p-3 h-fit space-y-1">
          {[
            { id: "general", label: "General", icon: "ri-settings-4-line" },
            { id: "roles", label: "Roles y Acceso", icon: "ri-shield-keyhole-line" },
            { id: "notif", label: "Notificaciones", icon: "ri-notification-3-line" },
            { id: "ia", label: "Asistente IA", icon: "ri-brain-line" },
          ].map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`w-full flex items-center gap-2.5 px-3 py-2 rounded-xl text-sm font-semibold transition-all cursor-pointer ${
                activeTab === tab.id
                  ? "bg-primary-50 text-text-foreground-600 border border-background-200"
                  : "text-foreground-500 hover:bg-background-50"
              }`}
            >
              <i className={tab.icon} />
              {tab.label}
            </button>
          ))}
        </Card>

        {/* Content Form */}
        <Card className="md:col-span-3 space-y-6">
          {activeTab === "general" && (
            <div className="space-y-4">
              <h3 className="text-base font-bold text-foreground-900 border-b border-background-100 pb-2">Información del Establecimiento</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <Input
                  label="Nombre del Colegio"
                  value={form.nombreCol}
                  onChange={e => setForm({ ...form, nombreCol: e.target.value })}
                />
                <Input
                  label="RUT Institucional"
                  value={form.rut}
                  onChange={e => setForm({ ...form, rut: e.target.value })}
                />
                <Input
                  label="Director / Sostenedor a Cargo"
                  value={form.director}
                  onChange={e => setForm({ ...form, director: e.target.value })}
                  className="md:col-span-2"
                />
              </div>
            </div>
          )}

          {activeTab === "roles" && (
            <div className="space-y-4">
              <h3 className="text-base font-bold text-foreground-900 border-b border-background-100 pb-2">Configuración de Seguridad</h3>
              <p className="text-xs text-foreground-500 mb-4">Configura los parámetros globales de la estructura de roles del establecimiento.</p>
              <div className="space-y-3">
                <label className="flex items-center gap-3 cursor-pointer p-3 rounded-xl border border-background-200/80 hover:bg-background-50 transition-colors">
                  <input
                    type="checkbox"
                    checked={form.auditoriasLogs}
                    onChange={e => setForm({ ...form, auditoriasLogs: e.target.checked })}
                    className="rounded border-background-300 text-primary-600 focus:ring-primary-400 w-4 h-4 cursor-pointer"
                  />
                  <div>
                    <p className="text-sm font-semibold text-foreground-800">Registrar Log de Auditoría Completo</p>
                    <p className="text-xs text-foreground-400">Guarda registro de IPs y navegadores en cada acción del sistema.</p>
                  </div>
                </label>
              </div>
            </div>
          )}

          {activeTab === "notif" && (
            <div className="space-y-4">
              <h3 className="text-base font-bold text-foreground-900 border-b border-background-100 pb-2">Preferencias de Alertas y Correo</h3>
              <div className="space-y-3.5">
                {[
                  { id: "notifCasos", title: "Nuevos casos e incidentes", desc: "Enviar alertas inmediatas cuando se cree un caso de convivencia." },
                  { id: "notifPlazos", title: "Vencimiento de plazos de informes", desc: "Avisar con 48 horas de anticipación sobre plazos del tribunal." }
                ].map(item => (
                  <label key={item.id} className="flex items-start gap-3 cursor-pointer p-3 rounded-xl border border-background-200/80 hover:bg-background-50 transition-colors">
                    <input
                      type="checkbox"
                      checked={form[item.id]}
                      onChange={e => setForm({ ...form, [item.id]: e.target.checked })}
                      className="rounded border-background-300 text-primary-600 focus:ring-primary-400 w-4 h-4 mt-0.5 cursor-pointer"
                    />
                    <div>
                      <p className="text-sm font-semibold text-foreground-800">{item.title}</p>
                      <p className="text-xs text-foreground-400 mt-0.5">{item.desc}</p>
                    </div>
                  </label>
                ))}
              </div>
            </div>
          )}

          {activeTab === "ia" && (
            <div className="space-y-4">
              <h3 className="text-base font-bold text-foreground-900 border-b border-background-100 pb-2">Configuración del Asistente IA</h3>
              <div>
                <label className="block text-sm font-semibold text-foreground-700 mb-1.5">Nivel de asistencia de la IA</label>
                <select
                  value={form.iaNivel}
                  onChange={e => setForm({ ...form, iaNivel: e.target.value })}
                  className="w-full text-sm rounded-lg border-2 border-background-300 bg-background-50 text-foreground-900 px-3.5 py-2.5 outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
                >
                  <option value="bajo">Bajo (Solo consultas normativas)</option>
                  <option value="medio">Medio (Sugerencias de redacción e informes)</option>
                  <option value="alto">Alto (Redacción automática de borradores e informes psicosociales)</option>
                </select>
                <p className="text-xs text-foreground-400 mt-1.5">El nivel alto permite que la IA redacte automáticamente resúmenes y propuestas de respuestas basadas en los insumos docentes.</p>
              </div>
            </div>
          )}

          <div className="flex justify-end gap-3 pt-4 border-t border-background-100">
            <Button variant="ghost">Reestablecer</Button>
            <Button onClick={handleSave} className="bg-primary-500 text-white hover:bg-primary-600">Guardar Cambios</Button>
          </div>
        </Card>
      </div>
    </div>
  );
}
